export enum OrganizationMemberRole {
    ADMIN = 'admin',
    USER = 'user'
}
